import * as React from 'react'
import { SVGProps } from 'react'
const SvgChartBar = (props: SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 89 89' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M75.13 11.18H50.38v16.5H31.13v16.5h-16.5v24.75h-2.75a2.75 2.75 0 1 0 0 5.5h66a2.75 2.75 0 0 0 0-5.5h-2.75V11.18Zm-5.5 57.75V16.68H55.88v52.25h13.75Zm-19.25 0V33.18H36.63v35.75h13.75ZM20.13 49.68h11v19.25h-11V49.68Z'
      fill={props.color ?? '#CC3E76'}
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M75.13 11.18H50.38v16.5H31.13v16.5h-16.5v24.75h-2.75a2.75 2.75 0 1 0 0 5.5h66a2.75 2.75 0 0 0 0-5.5h-2.75V11.18Zm-5.5 57.75V16.68H55.88v52.25h13.75Zm-19.25 0V33.18H36.63v35.75h13.75ZM20.13 49.68h11v19.25h-11V49.68Z'
      fill='url(#chart_bar_svg__a)'
      fillOpacity={0.25}
    />
    <defs>
      <linearGradient
        id='chart_bar_svg__a'
        x1={44.881}
        y1={11.18}
        x2={44.881}
        y2={74.43}
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#fff' />
        <stop offset={1} stopColor='#fff' stopOpacity={0} />
      </linearGradient>
    </defs>
  </svg>
)
export default SvgChartBar
